/**
 * DuckDB WebAssembly integration
 * @module @repo/engine/duckdb-wasm
 */

export * from './engine'; 